import type { MbcAdminCheck, MbcAdminCreateCheckBody } from "@nlc/shared-types";
import type { UseMutationResult } from "@tanstack/react-query";

import { mbcAdminKeys } from "@/hooks/queryKeys";

import { useMbcAdminMutation } from "../../useMbcAdminMutation";
import { createCheck } from "../api";

export function useCreateCheck(): UseMutationResult<
  MbcAdminCheck,
  Error,
  MbcAdminCreateCheckBody
> {
  return useMbcAdminMutation(createCheck, mbcAdminKeys.checks());
}
